export default {
  topFilters: ({ topFilters }) => topFilters,
};
